(function () {
	'use strict';

    angular.module("imApp").factory("docArticleService", ['$ihttp', function ($ihttp) {
		let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1376,
                    parameters: parms || {}
                });
            },
            listArticles: function (parms) {
                return $ihttp.post({
                    method: 1375,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
